import {ReactNode} from 'react';
import {VerifiedPermissionsProvider} from '@flexinet/auth-components';
import {actions} from '../config/rbac/actions.ts';
import permissions from '../config/permissions.ts';
import {useAuth} from '../hooks/useAuth.ts';

// The shared provider does not resolve the session itself; it waits on this
// app's AuthContext. Until the session resolves it reports `authorizing`, and a
// signed-out visit never reaches Verified Permissions at all. FNP-1728.
export const PermissionsProvider = ({children}: { children?: ReactNode }) => {
    const {status, user} = useAuth();
    return (
        <VerifiedPermissionsProvider
            actions={actions}
            policyStoreId={permissions.policyStoreId}
            region={permissions.region}
            actionType={`${permissions.namespace}::Action`}
            enabled={permissions.enabled}
            sessionStatus={status}
            sessionKey={status === 'authenticated' ? user?.userId : undefined}
        >
            {children}
        </VerifiedPermissionsProvider>
    );
};
